(() => {
  const key = 'wdlt-localization-session-v1';
  const read = () => {
    try { return JSON.parse(sessionStorage.getItem(key) || '{}'); }
    catch { return {}; }
  };
  const write = (state) => {
    try { sessionStorage.setItem(key, JSON.stringify(state)); return true; }
    catch { return false; }
  };
  if (!customElements.get('wdlt-localization')) {
    customElements.define('wdlt-localization', class extends HTMLElement {
      connectedCallback() {
        if (this.wdltBound) return;
        this.wdltBound = true;
        this.querySelector('select').addEventListener('change', (event) => {
          const country = event.target.value;
          write({ country, pending: { country, at: Date.now() } });
          this.querySelector('form').requestSubmit();
        });
      }
    });
  }
  const select = document.querySelector('wdlt-localization select');
  if (!select || window.Shopify?.designMode) return;
  const state = read();
  const pending = state.pending && Date.now() - state.pending.at < 60000;
  if (pending) {
    write({ country: select.value });
    return;
  }
  const reload = performance.getEntriesByType('navigation')[0]?.type === 'reload';
  if (!reload && state.country) return;
  if (select.value === 'CA') {
    write({ country: 'CA' });
    return;
  }
  if (!Array.from(select.options).some((option) => option.value === 'CA')) return;
  if (!write({ country: 'CA', pending: { country: 'CA', at: Date.now() } })) return;
  select.value = 'CA';
  select.form.requestSubmit();
})();
